/**
 * package: com.inq.aria
 * object: AriaMsg
 * @description
 */
com.inq.aria.AriaMsg = {};

/**
 * addAriaMsg
 * NOTE: to enable this function add the following element into mxml file.
 * All attributes are must.
 * <html:Div id="tc-aria-readme" aria-live="assertive" visible="true" position="absolute" left="-9999"></html:Div>
 *
 * When tc-aria-readme element is there, it set's the element's innerHTML with Msg.
 * public function addAriaMsg (Id:String, Msg:String, MsgType:Int):null
 * @param {string}  msg       - message
 * @param {number=} msgType - message type
 * @param {boolean=} force - forcing message reading
 */
com.inq.aria.AriaMsg.addAriaMsg = function (msg, msgType, force) {
	var _chatTxtArea = com.inq.flash.client.chatskins.ChatTextArea;
	if(typeof msgType === "undefined") {
		msgType = _chatTxtArea.SYSTEM;
	}
	if (typeof force === "undefined") {
		force = false;
	}
	// RTDEV-19508 - Making sure we get the mxml item every time
	com.inq.aria.AriaMsg.ariaMessage =
		Application.application.getMxmlItem("tc-aria-readme") || Application.application.getMxmlItem("tcChat_tc-aria-readme");
	com.inq.aria.AriaMsg.ariaMessageAndroidProxy =
			Application.application.getMxmlItem("tc-readme-proxy") || Application.application.getMxmlItem("tcChat_tc-readme-proxy");

	if (com.inq.aria.AriaMsg.ariaMessage == null || typeof com.inq.aria.AriaMsg.ariaMessage === "undefined") {
		return;
	}

	msg = com.inq.aria.AriaMsg.formatMsg(msg);
	msg = com.inq.aria.AriaMsg.removeHTMLMarkup(msg);

	if (msgType == _chatTxtArea.AGENT ||
		 msgType == _chatTxtArea.CUSTOMER ||
		 msgType == _chatTxtArea.SYSTEM ||
		 msgType == _chatTxtArea.SYSTEM_STATUS ||
		msgType == _chatTxtArea.SYSTEM_INFO) {
		if (com.inq.aria.AriaMsg.addAriaMsgLast !== msg || force) {
			// Android and Desktop don't read if message is same.
			// iPad is not checked yet.
			if (com.inq.utils.Capabilities.isAndroid()) {
				com.inq.aria.AriaMsg.ariaMessage._div.innerHTML = " ";
				if (com.inq.aria.AriaMsg.ariaMessageAndroidProxy != null) {
					com.inq.aria.AriaMsg.ariaMessageAndroidProxy._div.innerHTML = msg;
				}
			}

			var ariaElement = com.inq.aria.AriaMsg.ariaMessage._div;

			if (com.inq.flash.client.control.MinimizeManager.minimized && com.inq.flash.client.control.MinimizeManager.ariaMegMini) {
				ariaElement = com.inq.flash.client.control.MinimizeManager.ariaMegMini._div;
			}

			if (msg.trim().length > 0) {
				if (com.inq.utils.Capabilities.isMobile()) {
					/**
					 * RTDEV-22229: In mobiles, the aria-live (tc-aria-readme) div also gets focused when you swipe
					 * (this does not happen in desktop because of tabindex=-1). Hence, we will hide this div
					 * soon after setting the msg (500 ms). Even after you hide the div, the voice-over/talk-back will
					 * continue to read the msg.
					 */
					ariaElement.style.display = "block";
					appendMessageToParentElement(ariaElement, msg);
					window.setTimeout(
						function () {
							ariaElement.style.display = "none";
						}, 500);
				} else {
					appendMessageToParentElement(ariaElement, msg);
				}

				com.inq.aria.AriaMsg.addAriaMsgLast = msg;
			}
		}
	}

	/**
	 * We're using a <p>some message</p> element because IE does not support inserting strings
	 * using ParentNode.append("some message"), it only supports the older ParentNode.appendChild() which requires
	 * an actual element, not just a string. So we're using a span element to wrap the message, and
	 * then inserting the span element into the parent.
	 *
	 * @param {HTMLElement}	parentElement	The parent element
	 * @param {string}		message			A message we want to append to the parent element
	 */
	function appendMessageToParentElement(parentElement, message) {
		var messageElement = document.createElement("p");
		messageElement.innerHTML = message;
		parentElement.innerHTML = "";
		parentElement.appendChild(messageElement);
	}
};

/**
 * Formats messages to remove all unnecessary items from the message.
 *
 * Needs to change this method to remove HTML markup from the message.
 *
 * @param {string} msg
 * @return {string}
 */
com.inq.aria.AriaMsg.formatMsg = function (msg) {
	if (com.inq.utils.StringUtil.isEmptyString(msg)) {
		return msg;
	}

	msg = com.inq.aria.AriaMsg.removeATags(msg);
	/*
	* We have to remove all HTMLElements for android OS
	* to avoid a problems with pronouncement new messages.
	* In another cases we have to remove "id" attributes
	* to avoid problems with duplicate it on the web page.
	*/
	if (com.inq.utils.Capabilities.isAndroid()) {
		msg = com.inq.aria.AriaMsg.removeHTMLMarkup(msg);
	} else {
		msg = com.inq.aria.AriaMsg.removeIdAttributes(msg);
		if (com.inq.utils.Capabilities.isIpad() || com.inq.utils.Capabilities.isIphone()) {
			msg = com.inq.aria.AriaMsg.wrapMsg(msg);
		}
	}
	return msg;
};

/**
 * Remove A Tags from a message.
 * A tags are removed and Tag type "link" is added at the end of A content.
 * @param msg a String message which can contain A tags.
 * @returns {string}
 */
com.inq.aria.AriaMsg.removeATags = function (msg) {
	if (/<\/a/.test(msg)) {
		/*
		* Removes all <a> tags from the message but add A tag type (link)
		* to prevent unexpected screen reader behavior
		*/
		var addATagTypeLabel = com.inq.utils.Util.getConfig("addATagTypeLabel", false);
		msg = replaceAll(msg, /<\/a>/, addATagTypeLabel ? " link" : "");
		msg = replaceAll(msg, /<a[^>]*>/, "");
	}

	return msg;

	function replaceAll(str, a, b) {
		return str.split(a).join(b);
	}
};

/**
 * removeIdAttributes - is used to remove "id" attributes from
 * a message to prevent duplicate "id" attributes in the chat.
 *
 * @param {string} msg
 * @return {string}
 */
com.inq.aria.AriaMsg.removeIdAttributes = function (msg) {
	return msg.replace(/id=("|').+?("|')/gi, "");
};

/**
 * Removes all HTML elements with their attributes to avoid unexpected
 * behavior during pronouncement new messages in the live aria.
 *
 * @param {string} msg
 * @return {string}
 */
com.inq.aria.AriaMsg.removeHTMLMarkup = function (msg) {
	return msg.replace(/(?: )?<.*?>(?: )?/gi, " ").trim();
};

/**
 * Wraps message to HTMLDivElement, currently it is needed
 * for correct pronouncement new messages in the live aria.
 *
 * @param {string} msg
 * @return {string}
 */
com.inq.aria.AriaMsg.wrapMsg = function (msg) {
	return '<div>' + msg + '</div>';
};

com.inq.aria.AriaMsg.clearAriaMsg = function () {
	com.inq.aria.AriaMsg.addAriaMsg("");
};

com.inq.aria.AriaMsg.firstBufferedAriaMsgDelay = (function () {
	if (Application.IsPersistent()) {
		return (25 * 1000);
	}
	else {
		var _inTxt = ((com.inq.utils.Capabilities.isSafari() || com.inq.utils.Capabilities.isIOSWebView()) && com.inq.utils.Capabilities.isMobile())
			? "Double tap to start editing mode" : "Type your message here";
		return _inTxt.length * 4 * 60;
	}
})();


com.inq.aria.AriaMsg.addBufferedAriaMsg = function (id, msg, msgType, force) {
	var iniBuf;
	var item = {
		id: id,
		msg: msg,
		msgType: msgType,
		f: force
	};
	com.inq.aria.AriaMsg.ariaMessages.push(item);

	if (com.inq.aria.AriaMsg.ariaMessages.length == 1) {
		iniBuf = com.inq.aria.AriaMsg.firstBufferedAriaMsgDelay;
		com.inq.aria.AriaMsg.firstBufferedAriaMsgDelay = 0;
		com.inq.aria.AriaMsg.addBufferedAriaMsgTimerID =
			window.setTimeout(com.inq.aria.AriaMsg.sendAriaMsgAndCheckNext, iniBuf);
		com.inq.ui.Stage.getStageElement().onclick = com.inq.aria.AriaMsg.clearTimer;
		com.inq.ui.Stage.getStageElement().onkeyup = com.inq.aria.AriaMsg.clearTimer;
	}
};

/**
 * Used to queue initial aria messages
 * @param timer
 * @return {null|com.inq.utils.Timer}
 */
com.inq.aria.AriaMsg.sendAriaMsgAndCheckNext = function (timer) {
	var item = com.inq.aria.AriaMsg.ariaMessages.shift();
	com.inq.aria.AriaMsg.addAriaMsg(item.msg, item.msgType, item.f);

	if (0 < com.inq.aria.AriaMsg.ariaMessages.length) {
		com.inq.aria.AriaMsg.addBufferedAriaMsgTimerID =
			window.setTimeout(com.inq.aria.AriaMsg.sendAriaMsgAndCheckNext, item.msg.length * 90);
	}
	else {
		com.inq.aria.AriaMsg.clearTimer();
	}
};

/**
 * clearin the timer
 */
com.inq.aria.AriaMsg.clearTimer = function () {
	if (com.inq.aria.AriaMsg.addBufferedAriaMsgTimerID >= 0) {
		window.clearTimeout(com.inq.aria.AriaMsg.addBufferedAriaMsgTimerID);
	}
	com.inq.aria.AriaMsg.ariaMessages = [];
	if(com.inq.ui.Stage.getStageElement()) {
		com.inq.ui.Stage.getStageElement().onclick = null;
		com.inq.ui.Stage.getStageElement().onkeyup = null;
	}
};

/**
 * if there is a popup chat, announce the chat title to the screen reader. this is scheduled to Event.COMPLETE in
 * Application.prototype._init
 */
com.inq.aria.AriaMsg.onChatShown = function() {
	try {
        /*RTDEV-17529: Extending the fix of RTDEV-14748 to all types of chat, so that the title of the chatPanel is announced*/
		var oChatWithItem = Application.application.getMxmlItem("ChatWith");
		if(oChatWithItem) {
            com.inq.aria.AriaMsg.addAriaMsg(oChatWithItem.getText(), com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
        }
	} catch (e) { }
};

/**
 * Disable screen reader from reading the chat titlebar and the chat footer.  This will be called when the
 * switch canvas is displayed when the agent clicks the "Show Switch" in WebRTC mode.
 * RTDEV-19523
 */
com.inq.aria.AriaMsg.disableScreenReaderForChat = function() {
	var elm;
	var idsArray = ["tcChat_titleBar", "tcChat_chat"];
	for (var i=0; i<idsArray.length; i++) {
		elm = com.inq.ui.Container._getElementById(idsArray[i],parent.document);
		if (elm) {
			if (elm.hasAttribute("aria-hidden")) {
				elm.setAttribute("orig-aria-hidden", elm.getAttribute("aria-hidden"));
			}
			elm.setAttribute("aria-hidden", "true");
		}
	}
};

/**
 * Restore screen reader for chat.  This will be called when the switch canvas is hidden.  This can be done from AI or
 * CI
 * RTDEV-19523
 */
com.inq.aria.AriaMsg.restoreScreenReaderForChat = function() {
	var elm;
	var idsArray = ["tcChat_titleBar", "tcChat_chat"];
	for (var i=0; i<idsArray.length; i++) {
		elm = com.inq.ui.Container._getElementByI(idsArray[i],parent.document);
		if (elm) {
			if (elm.hasAttribute("orig-aria-hidden")) {
				elm.setAttribute("aria-hidden", elm.getAttribute("orig-aria-hidden"));
				elm.removeAttribute("orig-aria-hidden");
			} else if (elm.hasAttribute("aria-hidden")) {
				elm.removeAttribute("aria-hidden");
			}
		}
	}
};

/** @private @type {string} */
com.inq.aria.AriaMsg.addAriaMsgLast = "";

/** @private @type {Array.<Object>} */
com.inq.aria.AriaMsg.ariaMessages = [];

/** @private @type {Integer} */
com.inq.aria.AriaMsg.addBufferedAriaMsgTimerID = -1;